import React from 'react';

import CybsCard from '@cybs-ui/components/lib/card';
import {connect} from 'react-redux';
import { StructFlex, StructItem } from '@cybs-ui/components/lib/struct-flex';
import {putDataInDevCenterDataStore, getDevCenterDataStore} from '../../../../../app/store';
import {getPath} from '../../../../../lhs/reducers/lhs-reducer';
import '../css/live-console.css';

var hasQueryParams = false;
var queryParams = [];
var queryParamsCurrentValues = {};
var path = "";
var counter = 0;

class UrlEditor extends React.Component
{

  queryParamChecker = getDevCenterDataStore().subscribe(() => {

    if (this.props.liveConsoleTabIndex == 2 && hasQueryParams == true) {
        this.setState({ comment: 'Force render for Query Params two-way binding' });
    }

});
 
handleKeyPress = e => {
  if(e != undefined)
  {
    let keyPressed = e.key;

  if (/[0-9]/.test(keyPressed)) {
    e.preventDefault();
    }
  }
  
};

handlePaste = e => {
  let pastedText = e.clipboardData.getData("text/plain");

  if (/[0-9]/.test(pastedText)) {
    e.preventDefault();
  }
}


  render(){

    hasQueryParams = (this.props.hasQueryParams == undefined) ? false: this.props.hasQueryParams;
    queryParams = (this.props.queryParams == undefined) ? []: this.props.queryParams;
    queryParamsCurrentValues = (this.props.queryParamsCurrentValues == undefined) ? {}: this.props.queryParamsCurrentValues;

    var pathValue = getPath();
    if(pathValue == undefined){
      pathValue = '';
    }
    var apiHostURL = this.props.apiHostURL;
    return(
      <div id="urlEditor">
        <CybsCard
          // header={
          //   <CybsActionBar i18n={{ title: 'URL' }} dataTest="URL" />
            
          // }
          bodyMaxHeight={100}
          dataTest="URL"
          
        >
         {/* <CybsButton
            dataTest="secondaryButton"
            id = "editUrl"
            i18n={{ label: 'Edit Url' }}
            onClick={() => console.log('edit btn clicked')}
            colorScheme="secondary"
            style={{ marginTop: '-103px',marginLeft:'85%'}}
          /> */}
          <StructFlex>
            <StructItem style={{ flex: 1, marginRight: '1rem' }}>
            </StructItem>
          </StructFlex>
          <div style={{fontSize:'14px'}} class='single-line'>
          {/* <CybsTextfield
            dataTest="basic-input-percentage-1"
            id="default-input-percentage-1-example"
            name="default-percentage-1"
            type="text"
            width="100%"
            value = {this.props.methodType + ':' + 'https://apitest.cybersource.com' + this.props.path}
          /> */}
          {/* <span id ="methodTypeInUrlEditor">{this.props.methodType + ':'}</span
          > */}
          <div id="requestUrl" >
          <span id = "nonEditable" > {"https://" + apiHostURL}</span> 
          <span id= "urlValue"     onKeyUp = {() => { 
                          var spanText = document.getElementById("urlValue");
                          var text = spanText.innerHTML;
                          // putDataInDevCenterDataStore({type:'UPDATE_PATH',path:''});
                          putDataInDevCenterDataStore({type:'UPDATE_PATH',path:text});
                        }}
                        contentEditable={true}   
                        //value={this.props.path}
                        >
          {pathValue}
          </span>
          {
            hasQueryParams &&
            <span>?</span>
          }{
            hasQueryParams &&
            queryParams.map(queryParam => {
              if(queryParamsCurrentValues[queryParam.name] != undefined){
                return(
                  <span>
                    {
                      queryParamsCurrentValues[queryParam.name] != '' &&
                      <span>
                      <span>{queryParam.name + '='}</span
                      ><span
                        id = {queryParam.name}
                        onKeyUp = {() => {
                          var spanText = document.getElementById(queryParam.name);
                          queryParamsCurrentValues[queryParam.name] = spanText.innerHTML;
                          putDataInDevCenterDataStore({type:'UPDATE_QUERY_PARAMS_CONTROL',queryParamsControl:'requestUrl'});
                          putDataInDevCenterDataStore({type:'UPDATE_QUERY_PARAMETERS_CURRENT_VALUES',queryParamsCurrentValues:queryParamsCurrentValues});
                          putDataInDevCenterDataStore({ type: 'UPDATE_QUERY_PARAMETERS_COUNTER', queryParametersCounter: (++counter) });
                        }}
                        onChange = {() => {
                          var spanText = document.getElementById(queryParam.name);
                          queryParamsCurrentValues[queryParam.name] = spanText.innerHTML;
                          putDataInDevCenterDataStore({type:'UPDATE_QUERY_PARAMS_CONTROL',queryParamsControl:'requestUrl'});
                          putDataInDevCenterDataStore({type:'UPDATE_QUERY_PARAMETERS_CURRENT_VALUES',queryParamsCurrentValues:queryParamsCurrentValues});
                          putDataInDevCenterDataStore({ type: 'UPDATE_QUERY_PARAMETERS_COUNTER', queryParametersCounter: (++counter) });
                        }}
                      value={queryParamsCurrentValues[queryParam.name]}
                      contentEditable={true}
                      style={{border:'0px', marginRight:'0px'}}
                      >{queryParamsCurrentValues[queryParam.name]}</span>
                      <span>&</span
                  ></span>
                  }
                  </span>
                )
              }
              else{
                return(
                  <div></div>
                )
              }
            }
            )
          }
          </div>
          </div>
          {/* <p style={{marginLeft:'20px'}}>{this.props.methodType + ':' + 'https://apitest.cybersource.com' + this.props.path}</p> */}
        </CybsCard>
        
      </div>
    )     
  }
}

function mapStateToProps(state){
  
  return {
    methodType: state.lhsReducer.methodType,
    hasQueryParams: state.rhsReducer.hasQueryParams,
    queryParams: state.rhsReducer.queryParameters,
    queryParamsCurrentValues: state.rhsReducer.queryParamsCurrentValues,
    urlCounter:state.rhsReducer.urlCounter,
    apiHostURL:state.configurationReducer.apiHostURL
  }
  
}

export default connect(mapStateToProps)(UrlEditor);
